export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyD8dk5Q_5dphjEJSqXxzVmL5hehwpCei3o',
    authDomain: 'restless-society.firebaseapp.com',
    projectId: 'restless-society',
    storageBucket: 'restless-society.firebasestorage.app',
    messagingSenderId: '187149161231',
    appId: '1:187149161231:web:2c78732fa17787ad5ca47a',
    measurementId: 'G-R9X52WPR1R'
  },
  djangoApiUrl: 'https://newsletterservice.pythonanywhere.com/api' // Empty if not using Django backend 'https://newsletterservice.pythonanywhere.com/api
};
